<div #myIdentifier [ngStyle]="{'border-left':getColor(event)}" class="diary-event" (click)="showMore($event)">
  <div class="diary-event-main">
    <div class="diary-event-info">
      <div class="diary-event-title">
          <div class="diary-event-heading-text ui-g-3">
            <span>{{getDetailTypeText(event.DetailType, event.FallbackText, event.MatchType)}}</span>
          </div>
      </div>
      <div class="diary-event-subtitle">
        <div class="ui-g-3 diary-event-truncate">
          <span>{{event.EventTypeDescription}}</span>
          <span *ngIf="event.OptionBy"> - {{event.OptionBy}}</span>
        </div>
      </div>
      <div class="diary-event-body diary-event-truncate">
        <span *ngIf="event.LeaseRef">Ref: {{event.LeaseRef}} - {{event.TenantName}}</span>
        <span *ngIf="event.HeadLeaseRef">Ref: {{event.HeadLeaseRef}}</span>
      </div>
      <div class="diary-event-body">
        <div class="ui-g-3 diary-event-truncate">
          <span *ngIf="event.PropertyRef">{{event.PropertyRef}}</span><span *ngIf="event.UnitRef">/{{event.UnitRef}}</span>
          <span *ngIf="event.StrungAddress"> - {{event.StrungAddress}}</span>

        </div>
      </div>
    </div>

    <div class="diary-event-dates">
      <div class="diary-event-heading-date-passed-text ui-g-9 text-right">
        <span>{{getEventStatusText(event)}}</span>
      </div>
      <div class="diary-event-body">
        <span class="diary-event-details-list-value" *ngIf="shouldShowEventDate(event)">Event Date: {{event.EventDate | date:'dd MMM yyyy'}}</span>
      </div>
      <div class="diary-event-body">
        <span class= "diary-event-details-list-value" *ngIf="event.DateCompleted == null && event.NoticeDate && !isUndated">Noticed by: {{event.NoticeDate | date:'dd MMM yyyy'}}</span>
      </div>
      <div class="diary-event-body">
        <span class= "diary-event-details-list-value" *ngIf="isUndated && hasUndatedEventNotStarted(event)">Start Date: {{event.UDOStartDate | date:'dd MMM yyyy'}}</span>
      </div>
      <div class="diary-event-body">
        <span class= "diary-event-details-list-value" *ngIf="isUndated && hasUndatedEventEnded(event)">End Date: {{event.UDOEndDate | date:'dd MMM yyyy'}}</span>
      </div>
      <div class="diary-event-body">
        <span class= "diary-event-details-list-value" *ngIf="isUndated && isUndatedEventCurrent(event) && event.MinNoticePeriod && event.MinNoticePeriodType">Min Notice: {{event.MinNoticePeriod}} {{event.MinNoticePeriodType}}</span>
      </div>
      <div class="diary-event-body">
        <span class= "diary-event-details-list-value" *ngIf="isUndated && isUndatedEventCurrent(event) && event.NoticePeriod && event.NoticePeriodType">Max Notice: {{event.NoticePeriod}} {{event.NoticePeriodType}}</span>
      </div>
    </div>
  </div>


  <div class="diary-event-footer">
    <a>See more...</a>
  </div>

</div>
